<section class="cancel-info">
    <div class="card">
        <img [src]="approved ? './assets/images/cancel-approved.svg' : './assets/images/almost-there.svg'">
        <h3 class="card-title-bold">
            {{ approved ? 'Cancellation Request Sent' : 'Almost there' }}
        </h3>
        <p>
            {{ approved ? 
                'Please check your email in 10 hours for final confirmation decision.' : 
                'Please click the confirmation link in your email to confirm your cancellation request' }}
        </p>
    </div>
</section>
